import React, { Component, PropTypes } from 'react';
import StoreLayoutEditorToolbar from 'components/Store/StoreLayoutEditorToolbar';
import ScrollableContainer from 'components/Tasks/ScrollableContainer';
import StoreLayoutOverviewRow from './LayoutOverview/StoreLayoutOverviewRow';
import * as SvgIcons from 'components/Material/SvgIcons';
import { StoreOverviewActions } from 'actions';
import { default as TouchBackend } from 'react-dnd-touch-backend';
import { DragDropContext } from 'react-dnd';
import Preview from './LayoutOverview/Preview';
import {
  Toolbar,
  ToolbarTitle,
  ToolbarGroup,
  ToolbarButton
} from 'components/Toolbar';

class StoreLayoutEditor extends Component {
  static propTypes = {
    selectedModule: PropTypes.object,
    canUndo: PropTypes.bool,
    layout: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  openModuleMenu = () => {
    StoreOverviewActions.openModuleMenu();
  };

  render() {
    const { layout, canUndo, selectedModule } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <ScrollableContainer
        padded
        header={<StoreLayoutEditorToolbar canUndo={canUndo} />}
        footer={
          <Toolbar>
            <ToolbarGroup>
              <ToolbarButton onTouchTap={this.openModuleMenu}>
                <SvgIcons.ContentAdd />
              </ToolbarButton>
            </ToolbarGroup>
            <ToolbarTitle>{getIntlMessage('store.addContent')}</ToolbarTitle>
          </Toolbar>
        }
      >
        {layout.sections.map(section => {
          const { id, ...other } = section;
          return (
            <StoreLayoutOverviewRow
              id={id}
              key={id}
              {...other}
              selectedModule={selectedModule}
            />
          );
        })}
        <Preview key="preview" name="StoreColumn" />
      </ScrollableContainer>
    );
  }
}

export default DragDropContext(TouchBackend({ enableMouseEvents: true }))(
  StoreLayoutEditor
);



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/StoreLayoutEditor.js